// extracted by mini-css-extract-plugin
export default {"yj-font-style":"yj-font-style--Z3eXP","yj_cp_breadcrumb_wrapper":"yj_cp_breadcrumb_wrapper--B_1Fq","yj_cp_breadcrumb":"yj_cp_breadcrumb--LHTYY"};